import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { RelatedEntities } from "../abstracts/mixins/RelatedEntities";

import { updateTables } from "../../jobs-flow/updateTables";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";

export class JobRequest extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'request';
        this.urlRoot = '/jobs-flow/request';
        this.sectionRootUrl = '/jobs-flow';
        this.id = id;

        Object.assign(JobRequest.prototype, FormActions);
        Object.assign(JobRequest.prototype, EntityModalForm);
        Object.assign(JobRequest.prototype, HasStatus);
        Object.assign(JobRequest.prototype, RelatedEntities);
        Object.assign(JobRequest.prototype, HasAttachments);

        JobRequest.prototype.completeForm = function(formId, info=null, self=null) {
            const infoArr = Object.assign(FormActions.completeForm(formId, info, this), info);

            $('[data-job-id]').attr('data-job-id', this.id);
            if (infoArr.worker_comments) {
                JSON.parse(infoArr.worker_comments).forEach(element => {
                    $('#worker_comments_container').append(`<div class="mt-2">${element}</div>`)
                });
            }
        }
        this.setAttachmentCallbackPreview();
    }

    static statusList = {
        'submit': 1,
        'cancel': 2
    }

    convertToJob = () => {
        $.ajax({
            url: `${this.urlRoot}/${this.id}/convert-to-job`,
            method: 'POST',
            success: window.location.reload(true) //updateTables - не работает
        });
    }
}
